<template>
  <div>
    <PropostaAssinante ref="addAssinante" @close="execute"></PropostaAssinante>
    <core-grid ref="grid" :onRead="onRead" :schema="schema" server-side :delete-option="false" :add-option="false" :edit-option="false" filter-option grid-role="ListProposta" :roles="{ add: 'IncluirPropostaManual' }">
      <template v-slot:toolbar>
        <core-grid-button color="primary" @click="editar($event)" text="Novo" icon="fas fa-plus"> </core-grid-button>
      </template>
      <template v-slot:toolbar-append>
        <core-grid-button @click="exportarRelatorio($event)" text="Exportar Lista de Propostas" >
          <v-icon medium>fa fa-file-excel</v-icon>
        </core-grid-button>
      </template>
      <template slot="toolbar-append">
        <v-alert v-if="possuiDocPendente" border="left" class="mb-0" dense text style="display: inline-grid; height: 100%" color="warning">
          <v-icon color="warning" class="mr-2">mdi-alert-outline</v-icon>Existem Propostas com pendências, <a @click="filtrarPendencias">clique aqui para filtrá-las</a>
        </v-alert>
      </template>
      <template v-slot:[`item.CodigoProposta`]="{item}">
        <div class="d-flex flex-column font-weight-medium my-4">
          <span>
            {{ '#' + $api.UI.Format.LeftPadNumbers(item.CodigoProposta, 9) }}
          </span>
          <span class="text-caption">
            {{ $api.UI.Format.Date(item.DtInclusao, 'dd \'de\' MMMM \'de\' yyyy') }}
          </span>
        </div>
      </template>
      <template v-slot:[`item.NrRevisao`]="{item}">
        <v-chip v-if="existeRevisao(item.NrRevisao)" x-small class="ma-2" color="red" text-color="white">
          {{$api.UI.Format.LeftPadNumbers(item.NrRevisao, 3)}}
        </v-chip>
      </template>
      <template v-slot:[`item.NomeVendedor`]="{item}">
        <span class="d-flex flex-column font-weight-medium">
          {{ item.NomeVendedor}}
        </span>
      </template>
      <template v-slot:[`item.ClienteNome`]="{item}">
        <div class="d-flex flex-column font-weight-medium my-4">
          <span>
            {{ item.ClienteNome}}
          </span>
          <span class="text-caption">
            {{ item.ClienteDocumentoFederal }}
          </span>
        </div>
      </template>
      <template v-slot:[`item.VlrSolicitado`]="{item}">
        <div class="d-flex flex-column font-weight-medium my-4">
          <span>
            {{ $api.UI.Format.Currency(item.VlrSolicitado) }}
          </span>
          <span class="text-caption">
            {{ 'Em ' + item.QtdeParcelasSolicitado + 'x' }}
          </span>
        </div>
      </template>
      <template v-slot:[`item.VlrFinanciado`]="{item}">
        <div class="d-flex flex-column font-weight-medium my-4">
          <span>
            {{ $api.UI.Format.Currency(item.VlrFinanciado) }}
          </span>
          <span class="text-caption">
            {{ item.QtdeParcelas ? ('Em ' + item.QtdeParcelas + 'x') : '–' }}
          </span>
        </div>
      </template>
      <template v-slot:[`item.Situacao`]="{item}">
        <v-chip x-small outlined class="ma-2 px-2" color="primary"  v-if="item.PendenteConferenciaEmpresa === true">
          Documentos Pendentes
        </v-chip>
        <v-chip x-small outlined class="ma-2 px-2" color="primary" v-else>
          {{ $aux.Situacao.find(p => p.value === item.Situacao).text }}
        </v-chip>
      </template>
      <template  v-slot:[`item.Revisao`]="{item}">
        <v-btn @click="revisarProposta($event, item.Codigo)" x-small color="primary" v-if="userHasRole('FindRecordProposta') && (item.Situacao === $aux.SituacaoPropostaEnum.Recusada)">Revisão</v-btn>
      </template>
    </core-grid>
    <modal-filtro ref="filtrar" model="filtro" @refresh="refresh">
      <v-row>
        <v-col cols="6">
          <input-date v-if="!filtro.filtraPendencias" label="Incluído de" v-model="filtro.dataInicio"></input-date>
          <input-text prepend-inner-icon="event" v-else disabled label="Incluído de" :value="$api.UI.Format.Date(filtro.dataInicio)"></input-text>
        </v-col>
        <v-col cols="6">
          <input-date v-if="!filtro.filtraPendencias" label="Até" :min="filtro.dataInicio" v-model="filtro.dataTermino"></input-date>
          <input-text prepend-inner-icon="event" v-else disabled label="Até" :value="$api.UI.Format.Date(filtro.dataTermino)"></input-text>
        </v-col>
        <v-col cols="12">
          <input-select :options="$aux.Situacao" label="Situação" v-model="filtro.situacao"></input-select>
        </v-col>
        <v-col cols="12">
          <v-checkbox label="Filtrar propostas com pendências" v-model="filtro.filtraPendencias"></v-checkbox>
        </v-col>
      </v-row>
    </modal-filtro>
    <PropostaAcoes ref="acoes" @close="response" />
    <PropostaPagamentoEdit ref="revisao" @close="response" />
    <PropostaPendencias ref="pendencias" @close="response" />
  </div>
</template>
<script>
import PropostaPagamentoEdit from './PropostaPagamentoEdit'
export default {
  components: {
    PropostaAssinante: () => import('./PropostaAssinante'),
    PropostaAcoes: () => import('./PropostaAcoes'),
    PropostaPendencias: () => import('./PropostaPendencias'),
    PropostaPagamentoEdit
  },
  data () {
    return {
      possuiDocPendente: false,
      emailGerentes: '',
      filtro: {
        dataInicio: this.$api.UI.Format.Date(this.$api.UI.Date.AddDay(new Date(), -28), 'yyyy-MM-dd'),
        dataTermino: this.$api.UI.Format.Date(new Date(), 'yyyy-MM-dd')
      },
      schema: [
        { text: '#', value: 'CodigoProposta', width: '200' },
        { text: 'Rev.', value: 'NrRevisao', align: 'center', width: '20' },
        { text: 'Vendedor', value: 'NomeVendedor' },
        { text: 'Cliente', value: 'ClienteNome' },
        { text: 'Solicitado', value: 'VlrSolicitado', width: '120' },
        { text: 'Aprovado', value: 'VlrFinanciado', width: '120' },
        { text: 'Situação', value: 'Situacao', align: 'center', width: '100' },
        { value: 'Revisao', width: '80' },
        { format: 'button', action: this.revisao, icon: 'fas fa-university', tooltip: 'Alterar dados bancários', width: '20', condition: p => p.Situacao === this.$aux.SituacaoPropostaEnum.PendentePagamento },
        { format: 'button', action: this.editar, icon: 'fa-pencil-alt', tooltip: 'Editar', value: 'Editar', align: 'center', width: '20', condition: p => p.Situacao === this.$aux.SituacaoPropostaEnum.EmDigitacao },
        {
          format: 'button',
          action: this.adicionarAssinante,
          icon: 'fas fa-file-signature',
          tooltip: 'Firmas e Poderes',
          value: 'Assinantes',
          align: 'center',
          width: '20',
          condition: p =>
            this.userHasRole('FindRecordProposta') &&
            [
              this.$aux.SituacaoPropostaEnum.EmDigitacao,
              this.$aux.SituacaoPropostaEnum.EmAnalise,
              this.$aux.SituacaoPropostaEnum.Aprovada
            ].includes(p.Situacao)
        },
        { format: 'button', action: this.acoes, tooltip: 'Ações', icon: 'fas fa-list', value: 'Acoes', align: 'center', width: '20' },
      ]
    }
  },
  methods: {
    onRead: function (options, search) {
      const th = this
      const dto = {
        ...options,
        parameters: [
          { name: 'search', value: search },
          { name: 'DataInicio', value: th.filtro.dataInicio },
          { name: 'DataTermino', value: th.filtro.dataTermino },
          { name: 'Situacao', value: th.filtro.situacao },
          { name: 'FiltraPendenciasFormalizacao', value: th.filtro.filtraPendencias },
          { name: 'DocumentoParceiroCorrespondente', value: th.$empresa.documentoFederal }
        ]
      }
      if (th.$user.roles === 'Multiplo.Gerente') {
        dto.parameters.push({ name: 'FiltraGerente', value: true })
        dto.parameters.push({ name: 'EmailGerentes', values: th.emailGerentes })
        dto.parameters.push({ name: 'EmailMasters', values: th.emailMasters })
      } else if (th.$user.roles === 'Multiplo.Operador') {
        dto.parameters.push({ name: 'FiltraVendedor', value: true })
      }

      th.$api.Multiplo.Post('ExistePropostaPendente', dto).then(function (response) {
        th.possuiDocPendente = false
        if (th.$api.UI.PostLoadData(response)) {
          th.possuiDocPendente = response === true
        }
      })

      th.$api.Multiplo.Post('ListProposta', dto).then(function (response) {
        if (th.$api.UI.PostLoadData(response)) {
          options.success(response.Data, response.Count)
        }
      })
    },
    existeRevisao (NrRevisao) {
      if (NrRevisao) return true
      return false
    },
    revisarProposta (event, codigo) {
      const th = this
      event.preventDefault()
      th.$api.UI.Confirmacao('alerta', 'Tem certeza que deseja permitir a edição da proposta?',
        () => {
          th.$api.Multiplo.Post('FindRecordProposta', { guidID: codigo }).then(function (response) {
            if (th.$api.UI.PostLoadData(response)) {
              const dto = {
                dto: {
                  CodigoProposta: response.Codigo
                },
                dtoReanalise: {
                  ...response,
                  DocumentoCliente: response.Cliente.DocumentoFederal,
                  Prazo: response.QtdeParcelasSolicitado,
                  DocumentoParceiroCorrespondente: th.$api.UI.Format.SomenteNumeros(th.$empresa.documentoFederal),
                  PercJurosNegociado: response.PercJurosMensal,
                }
              }
              th.$api.Multiplo.Post('EnviarPropostaReanaliseManual', dto).then(function (responseReanalise) {
                if (th.$api.UI.PostLoadData(responseReanalise, true)) {
                  th.$api.Multiplo.Post('FindRecordProposta', { guidID: codigo }).then(function (response) {
                    if (th.$api.UI.PostLoadData(response)) {
                      const dto = response
                      dto.ByPassSituacaoOnSave = true
                      dto.UsarJurosProposta = true
                      dto.Situacao = th.$aux.SituacaoPropostaEnum.EmDigitacao
                      th.$api.Multiplo.Post('SaveProposta', { dto }).then(function (response) {
                        if (th.$api.UI.PostLoadData(response)) {
                          th.refresh()
                        }
                      })
                    }
                  })
                }
              })
            }
          })
        },
        () => {
          th.$api.UI.ShowError(th.$getErrorMessage('operacao.cancelada.title'))
        },
        'Permitir Edição da Proposta'
      )
    },
    editar (e, current) {
      e.preventDefault()
      const th = this
      if (th.$param.EST_PRODUTOS) {
        if (th.$param.EST_PRODUTOS.flatMap(p => p.Produtos).filter(el => el).length > 0) {
          if (current) {
            th.$router.push({ path: `/propostas?codigoProposta=${current.Codigo}`, })
          } else {
            th.$router.push('/propostas')
          }
        } else {
          th.$api.UI.ShowAlert('Alerta', 'Nenhum produto foi configurado para este portal. Por gentileza, contate o administrador.')
        }
      } else {
        th.$api.UI.ShowAlert('Alerta', 'O parâmetro de produto não foi configurado para este portal. Por gentileza, contate o administrador.')
      }
    },
    acoes (event, current) {
      event.preventDefault()
      const th = this
      if (current.PendenteConferenciaEmpresa === true) {
        th.$refs.pendencias.openModal(current)
      } else {
        th.$refs.acoes.openModal(current)
      }
    },
    revisao (event, current) {
      event.preventDefault()
      const th = this
      if (current) {
        th.$refs.revisao.openModal(current)
      }
    },
    adicionarAssinante (e, curr) {
      e.preventDefault()
      const th = this
      if (curr) {
        th.$refs.addAssinante.openModal(curr)
      }
    },
    filtrarPendencias () {
      this.$set(this.filtro, 'filtraPendencias', true)
      this.refresh()
    },
    refresh () {
      this.$refs.grid && this.$refs.grid.refresh()
    },
    response: function (data) {
      if (data) { this.refresh() }
    },
    execute (response, param) {
      if (param === 'openAction') {
        this.$refs.acoes.openModal({ Codigo: response })
      }
    },
    exportarRelatorio (e) {
      const th = this
      const dto = {
        parameters: [
          { name: 'DataInicio', value: th.filtro.dataInicio },
          { name: 'DataTermino', value: th.filtro.dataTermino },
          { name: 'Situacao', value: th.filtro.situacao },
          { name: 'CarregaTipoContrato', value: true },
          {
            name: 'DocumentoParceiroCorrespondente',
            value: th.$empresa.documentoFederal,
          },
        ],
      };
      th.$api.Exportacao.RelatorioCompleto(th, e, dto)
    }
  },
  mounted () {
    const th = this
    if (th.$user.roles === 'Multiplo.Gerente') {
      th.$api.Usuario.GetEmailGerentes().then(function (response) {
        th.emailGerentes = response.map(p => p.email)
        th.$api.Usuario.GetEmailMasters().then(function (response) {
          th.emailMasters = response.map(p => p.email)
          th.refresh()
        })
      })
    } else if (th.$user.roles === 'Multiplo.Master') {
      th.$api.Usuario.GetEmailMasters().then(function (response) {
        th.emailMasters = response.map(p => p.email)
        th.refresh()
      })
    } else {
      th.refresh()
    }

    if (th.$route.query.model) {
      th.refresh()
      th.$api.UI.Timeout.Default(() => {
        if (th.$refs.addAssinante) {
          th.$refs.addAssinante.openModal(this.$route.query.model, 'openAction')
        } else { return 10 }
      })
    }
  }
}
</script>
